import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { captureUtmsFromUrl } from '../../lib/utm';

/**
 * UtmCapture: drop-in component (renders nothing).
 * On every navigation that brings UTMs in the query string, atomically
 * replaces the persisted UTM cookies. Reads on mount + on each location change.
 */
const UtmCapture = () => {
  const location = useLocation();

  useEffect(() => {
    captureUtmsFromUrl(location.search);
  }, [location.search]);

  return null;
};

export default UtmCapture;
